<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    color?: 'black' | 'white'
    offset?: string
  }>(),
  {
    color: 'black',
    offset: '0px',
  }
)

const colorClass = computed(() => (props.color === 'black' ? 'bg-black' : 'bg-white'))
</script>

<template>
  <div class="absolute inset-0 pointer-events-none">
    <!-- Top Left -->
    <div class="absolute opacity-30" :style="{ left: offset, top: offset }">
      <div class="h-3 w-[1px]" :class="colorClass"></div>
      <div class="w-3 h-[1px] absolute" :class="colorClass" style="left: -20px; top: 20px"></div>
    </div>
    <!-- Top Right -->
    <div class="absolute opacity-30" :style="{ right: offset, top: offset }">
      <div class="h-3 w-[1px]" :class="colorClass"></div>
      <div class="w-3 h-[1px] absolute" :class="colorClass" style="right: -20px; top: 20px"></div>
    </div>
    <!-- Bottom Left -->
    <div class="absolute opacity-30" :style="{ left: offset, bottom: offset }">
      <div class="h-3 w-[1px]" :class="colorClass"></div>
      <div class="w-3 h-[1px] absolute" :class="colorClass" style="left: -20px; bottom: 20px"></div>
    </div>
    <!-- Bottom Right -->
    <div class="absolute opacity-30" :style="{ right: offset, bottom: offset }">
      <div class="h-3 w-[1px]" :class="colorClass"></div>
      <div class="w-3 h-[1px] absolute" :class="colorClass" style="right: -20px; bottom: 20px"></div>
    </div>
  </div>
</template>

